import axios from 'axios';
import sortBy from 'lodash/sortBy';
import { captureException } from '../../../tracker/raven';
import { BASE_URL } from '../../../utils/config';

interface ProjectProduct {
    name: string;
}
interface ProjectRecord {
    project: string;
    products?: Record<string, ProjectProduct[]>;
}
interface SaleItem {
    product: string;
    category: string;
    campaign: string;
}

export const getSalesTrackingData = async ({ authToken }: { authToken: string }) => {
    return axios
        .get(`${BASE_URL}/kpi/v1/projects`, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(({ data }: { data: ProjectRecord[] }) => {
            const listOfProjects = Array.isArray(data) ? data : [];
            return sortBy(
                listOfProjects.reduce((prevValue: SaleItem[], project: ProjectRecord) => {
                    const products: SaleItem[] = [];
                    const categories = project?.products || {};
                    Object.keys(categories).forEach((category: string) => {
                        const productsOfCategory = categories[category] || [];
                        productsOfCategory.forEach(({ name }: { name: string }) => {
                            products.push({
                                product: name,
                                category,
                                campaign: project.project
                            });
                        });
                    });

                    return prevValue.concat(products);
                }, []),
                ['campaign', 'category', 'product']
            );
        })
        .catch((e: Error | string) => {
            captureException(e);
            return [];
        });
};
